import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartHorizontalMultiBar } from 'src/common/charts';
import { fetchMilitaryReports } from 'actions/Report/Contact/Military';
import _ from 'lodash';
import { serviceBranchesPartitions, networkServiceBranchesPartitions } from '../../utils/partitions';
import { serviceBranchesColors } from '../../utils/colors';
import sortByTitleNoResponseLast from '../../utils/sortByTitleNoResponseLast';

export default class TransitioningByBranch extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      transitioningByBranch: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;
    const partitions = scope === 'group' ? serviceBranchesPartitions() : networkServiceBranchesPartitions();
    fetchMilitaryReports(scope, id, 'transitioning/by-branch-of-service', { partitions, ...filters })
      .then((response) => {
        const data = _.get(response, 'data', {});
        data.values = sortByTitleNoResponseLast(data.values);
        this.setState({
          transitioningByBranch: data,
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('transitioningByBranch');
      });
  }

  render() {
    if (_.isEmpty(this.state.transitioningByBranch)) {
      return null;
    }
    return (
      <ChartHorizontalMultiBar
        data={this.state.transitioningByBranch}
        x={(d) => _.truncate(d.title, { length: 40 })}
        y={(d) => d.total}
        title={this.state.title}
        margin={{ left: 280, top: 60 }}
        showValues
        showYAxis
        showLegend
        stacked
        valueFormat="d"
        maxKeyLength={60}
        colors={serviceBranchesColors}
        xLabel="Transitioning Status"
        colWidths={{
          x: '270px',
        }}
      />
    );
  }
}

TransitioningByBranch.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
